import { Link } from "react-router-dom";
import Seo from "../lib/seo";

export default function NotFoundPage() {
    return (
        <>
            <Seo title="Page Not Found" description="The page you're looking for could not be found." path="/404" />
            <section className="min-h-[70vh] flex items-center justify-center bg-editorial py-24" data-testid="not-found">
                <div className="text-center px-6 max-w-xl">
                    <p className="overline mb-6 text-coral">404</p>
                    <h1 className="font-serif text-5xl md:text-7xl text-navy-900 leading-tight mb-6">
                        This page took a wrong turn.
                    </h1>
                    <p className="text-lg text-navy-800/75 mb-10">
                        Let's get you back to safer ground. JC's mission needs every second.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <Link to="/" className="px-7 py-3.5 bg-navy-900 text-editorial hover:bg-navy-800 transition-colors">Return Home</Link>
                        <Link to="/our-story" className="px-7 py-3.5 border border-navy-900 hover:bg-navy-900 hover:text-editorial transition-colors">Read JC's Story</Link>
                    </div>
                </div>
            </section>
        </>
    );
}
